"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../../utils");

var _constants = require("../utils/constants");

var _SortIcon = _interopRequireDefault(require("./SortIcon"));

var _Filter = _interopRequireDefault(require("./Filter"));

var _ColumnConfig = _interopRequireDefault(require("./ColumnConfig"));

var _types = require("../utils/types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function HeaderCell(props) {
  var column = props.column,
      columns = props.columns,
      sorting = props.sorting,
      filtering = props.filtering,
      changeColumns = props.changeColumns,
      changeSorting = props.changeSorting,
      changeFiltering = props.changeFiltering,
      headerControls = props.headerControls;
  var key = column.key,
      title = column.title,
      width = column.width,
      hidden = column.hidden,
      minWidth = column.minWidth,
      sorter = column.sorter,
      sortableProp = column.sortable,
      filters = column.filters,
      filterable = column.filterable,
      titleType = column.titleType,
      className = column.className,
      onHeaderCell = column.onHeaderCell,
      headerClassName = column.headerClassName;
  if (hidden) return null;
  var sortable = sortableProp || typeof sorter === 'function';
  var hasActiveSort = sorting.key === key;
  var sortDirection = hasActiveSort ? _constants.SORT_ORDER.indexOf(sorting.direction) : 0;
  var filterValues = filtering.find(function (item) {
    return item.key === key;
  }) || {
    key: key,
    value: []
  };

  var _ref = typeof onHeaderCell === 'function' ? onHeaderCell(column) : {},
      classNameProp = _ref.className,
      headerCellPops = _objectWithoutProperties(_ref, ["className"]);

  var classNameTH = (0, _utils.getClassNames)(className, headerClassName, classNameProp, {
    'column-sort': sortable
  }, {
    'column-filter': filterable
  }, {
    sorted: hasActiveSort
  }, {
    filtered: filterValues.value.length > 0
  });

  var onSort = function onSort() {
    changeSorting(sortDirection === _constants.SORT_ORDER.length - 1 ? {} : {
      key: key,
      sorter: sorter,
      direction: _constants.SORT_ORDER[sortDirection + 1]
    });
  };

  var onFilter = function onFilter(value) {
    changeFiltering({
      key: key,
      value: value
    });
  };

  var onClick = function onClick() {
    if (sortable) onSort();
  };

  if (titleType === 'columns') {
    return /*#__PURE__*/_react.default.createElement("th", _extends({
      role: "columnheader",
      key: key,
      width: width,
      style: {
        minWidth: minWidth
      }
    }, headerCellPops), /*#__PURE__*/_react.default.createElement(_ColumnConfig.default, {
      columns: columns,
      changeColumns: changeColumns,
      headerControls: headerControls
    }));
  }

  return /*#__PURE__*/_react.default.createElement("th", _extends({
    role: "columnheader",
    key: key,
    width: width,
    style: {
      minWidth: minWidth
    },
    className: classNameTH
  }, headerCellPops), /*#__PURE__*/_react.default.createElement("span", {
    role: "button",
    className: "header-column",
    onClick: onClick
  }, title !== undefined ? title : key, sortable && /*#__PURE__*/_react.default.createElement(_SortIcon.default, {
    isSorted: hasActiveSort,
    direction: _constants.SORT_ORDER[sortDirection],
    handleSort: onSort
  })), filterable && /*#__PURE__*/_react.default.createElement(_Filter.default, {
    filters: filters,
    selectedKeys: filterValues.value,
    headerControls: headerControls,
    setSelectedKeys: onFilter
  }));
}

HeaderCell.propTypes = {
  column: _propTypes.default.shape({
    key: _propTypes.default.string,
    title: _propTypes.default.string,
    width: _propTypes.default.oneOf(_propTypes.default.string, _propTypes.default.number),
    minWidth: _propTypes.default.oneOf(_propTypes.default.string, _propTypes.default.number),
    hidden: _propTypes.default.bool,
    sorter: _propTypes.default.func,
    sortable: _propTypes.default.bool,
    filters: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string,
      value: _propTypes.default.string
    })),
    filterable: _propTypes.default.bool,
    titleType: _propTypes.default.string,
    className: _propTypes.default.string,
    headerClassName: _propTypes.default.string,
    onHeaderCell: _propTypes.default.func
  }),
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string,
    title: _propTypes.default.string,
    width: _propTypes.default.oneOf(_propTypes.default.string, _propTypes.default.number),
    minWidth: _propTypes.default.oneOf(_propTypes.default.string, _propTypes.default.number),
    hidden: _propTypes.default.bool,
    sortable: _propTypes.default.bool,
    className: _propTypes.default.string
  })),
  sorting: _types.sortState,
  filtering: _types.filteringState,
  changeColumns: _propTypes.default.func,
  changeSorting: _propTypes.default.func,
  changeFiltering: _propTypes.default.func,
  headerControls: _propTypes.default.shape({
    selectControlsLabel: _propTypes.default.shape({
      selectAll: _propTypes.default.string,
      reset: _propTypes.default.string
    }),
    sortByLabel: _propTypes.default.string
  }).isRequired
};
HeaderCell.defaultProps = {
  column: {
    key: null,
    title: undefined,
    width: null,
    minWidth: null,
    hidden: false,
    sortable: false,
    className: undefined
  },
  columns: [],
  sorting: null,
  filtering: null,
  changeColumns: function changeColumns() {},
  changeSorting: function changeSorting() {},
  changeFiltering: function changeFiltering() {}
};
var _default = HeaderCell;
exports.default = _default;